import type { Priority } from "@/features/orders/types";
import type { OfficialApplicationQueueRow } from "@/features/power_projects/types";

/** Rodzaj pozycji w zbiorczym „Do zatwierdzenia" — lustro KIND_* z apps.core.director_approvals. */
export type ApprovalKind = "requisition" | "official_fee" | "application";

export const APPROVAL_KIND_LABELS: Record<ApprovalKind, string> = {
  requisition: "Zapotrzebowanie",
  official_fee: "Opłata urzędowa",
  application: "Wniosek urzędowy",
};

interface ApprovalRowBase {
  id: string;
  title: string;
  subtitle: string;
  project_name: string;
  /** Kwota jako napis dziesiętny; null = brak kwoty (wniosek) albo żadna nie jest widoczna. */
  amount: string | null;
  requested_by_name: string;
  waiting_since: string | null;
  /** Ścieżka frontendu do pełnego widoku pozycji w jej module. */
  detail_path: string;
  note: string;
}

export type ApprovalRow =
  | (ApprovalRowBase & {
      kind: "requisition";
      extra: {
        deadline: string | null;
        priority: Priority;
        /** Typ WPW zapotrzebowania z zakładki „Działki" — okno zatwierdzania go blokuje. */
        suggested_order_type: string | null;
        /** Suma tylko z pozycji, których stawki widzisz. */
        amount_partial: boolean;
      };
    })
  | (ApprovalRowBase & {
      kind: "official_fee";
      extra: {
        above_threshold: boolean;
        /** Zamówienie, do którego wnioskujący przypisał opłatę (u podwykonawcy obowiązkowe). */
        order_id: string | null;
        order_number: string | null;
      };
    })
  | (ApprovalRowBase & { kind: "application"; extra: { queue_row: OfficialApplicationQueueRow } });

export interface DirectorApprovalsResponse {
  data: ApprovalRow[];
  meta: {
    count: number;
    /** Rodzaje, które ta osoba w ogóle zatwierdza (np. bez wniosków, gdy obieg wyłączony). */
    kinds: ApprovalKind[];
    counts: Partial<Record<ApprovalKind, number>>;
  };
}
